//**************************************************************
import { 
          Component,
          ViewChild,
          Inject,
        
          LOCALE_ID,
          ChangeDetectorRef,
          AfterContentChecked
        }                               from '@angular/core';



// Router
import { Router, ActivatedRoute }       from '@angular/router';

import { Observable, Subscription }     from 'rxjs';
//**************************************************************
// Firestore 
import { firestorecontrol }             from "../../appfirestore/app.firestore";
//**************************************************************
// Devexpress 
import {  
          DxFormComponent,
          DxSchedulerComponent,
          DxGanttComponent,
          DxToolbarComponent,
          DxSliderComponent,
          DxDataGridComponent      
      }                                   from 'devextreme-angular';

import Toolbar                            from "devextreme/ui/toolbar"

import Button                             from 'devextreme/ui/button'

import { DxValidationGroupComponent }     from 'devextreme-angular/ui/validation-group';

import { PositionConfig }                 from "devextreme/animation/position"

import { custom }                         from 'devextreme/ui/dialog';
//**************************************************************
// Field Definitions
import  { 
          gantttask,
          dependency,
          scheduler,
          collaboratordetail,
          costallocation,
          whoseguestinit
        }                                 from '../../appfirestore/app.fields';
//**************************************************************
// Functions
import { appfunctions  }                                    from '../../functions/app.functions';
// List Structures
import { liststructures }               from '../../classinjection/app.liststructures'

import { FormatWidth, formatDate, getLocaleDateFormat }     from '@angular/common';

import 'devextreme/integration/jquery';
import { fas } from '@fortawesome/free-solid-svg-icons';
//*******************************************************
@Component(
              {
                selector: 'app-comtodo',
                templateUrl: './comtodo.component.html',
                styleUrls: ['./comtodo.component.scss'],
                preserveWhitespaces: true,
              }
        )
//*******************************************************
export class ComtodoComponent 
  {
    //*******************************************************
    eventid: string = '';
    formheight: number = 0;
    //*******************************************************
    @ViewChild('gridtodotask') gantttodo: DxGanttComponent;
    @ViewChild('scheduler') scheduler: DxSchedulerComponent;

    @ViewChild('formtodotask') formtodotask: DxFormComponent;
    @ViewChild('formcollaborator') formcollaborator: DxFormComponent;

    @ViewChild('grideventcollaborator') dataCollaboratorGrid: DxDataGridComponent;

    @ViewChild('sssss') toolbarInstance: DxToolbarComponent;
    @ViewChild("sliderprogress") sliderProgress: DxSliderComponent;
    //*******************************************************
    // Firestore Paths
    pathcollaborator: string = "/eventcollaborator/collaborator" 

    // eventinvitee
    subscriptiontodo: Subscription;
    subscriptiontodolist: gantttask[];

    subscriptiontododependency: Subscription;
    subscriptiontodolistdependencylist: dependency[];

    subscriptionscheduler: Subscription;
    subscriptionschedulerlist: scheduler[];

    subscriptioncollaborator: Subscription;
    subscriptioncollaboratorlist: collaboratordetail[];

    tasks: gantttask[];
    ganttid: string;
    parentID: number;
    parenttaskid: string;
    gantttaskid: string;
    gantttaskbudget: number = 0;
    schedulerparenttaskid: string;
    selectedRowKey: any;

    formData: Array<gantttask> = [];
    formDataVarible: any;
    statusvaluechange: boolean = false;
    statusinsert: boolean = false;

    popuptitle: string = 'Task Detail Profile';
    popuptaskdetailVisible: boolean = false

    dateformat: string;

    formScheduleData: Array<scheduler> = [];
    popupscheduleVisible: boolean = false;
    positionOf: string;
    toastposX: number = 0;
    toastposY: number = 25;
    scheduleview: string = "day"
    agendaageduration: number = 30;

    popupserviceVisible: boolean = false;


     // Collaborator Form
     formcollaboratorData: Array<collaboratordetail>
     formcollaboratorDataVarible: any;

     rowCollaboratordata: any;
     rowCollaboratorSelect: boolean = false;
     popupcollaboratorVisible: boolean = false; 
     focusedCollaboratorRowKey: number = 0;
     focusedCollaboratorOldStatus: string;
     focusedCollaboratorGanttid: string;
     focusedCollaboratorCurrActCost: number;
     focusedCollaboratorCurrBudCost: number;
     focusedCollaboratorStatusList: String;
     collabstatusinputvalmsg: string = '';

     collaboratordetails: Array<collaboratordetail> = []; // Empty Array
 
    // Button
    selButton: number;
    buttondisable: boolean = true;

   // currentDate: Date = new Date()
    todayDate: Date = new Date()
    currentDate: string = formatDate( new Date(), 'yyyy-MM-dd', 'en' );
    currentsdate: Date;
    currentedate: Date;

    ganttstartdate: Date  = new Date  // Set Date as today date
    ganttenddate: Date    = new Date  // Set Date as today date

    // Toast Messages
    toastFileMessage: string = '';
    toastVisible: boolean = false;
    toasttypeerror: string = 'error';
    toastdisplaytime: number = 3000;
    toastwidth: string = '240';
    settoastwidth: string = '240';

    localeDate = getLocaleDateFormat( this.locale, FormatWidth.Long)

    myDialog: any;

    onAppointmentFormOpeningStatus: boolean = true;

    progress1: number = 0;
    startdateinputvalmsg: string;
    enddateinputvalmsg: string;
    budgetinputvalmsg: string;

    labelTemplates: any[];

    collaboratorstatus: Array<string> = [];
    selcollaboratorstatus: string;
    statusflag: string = '';
    collaboratorid: string = '';
    sharecost: any[] = [];
    collabcost: number = 0;
    collabbudcost: number = 0;
    isValid: boolean = true;
    
    // Cost Allocation
    whoseguest: Array<whoseguestinit> = []; // Empty Array
    organisercostallocation: Array<costallocation> = [];
    saveorganisercostallocation: Array<string> = [];
    saveorganisercostallocationstring: string = '';
    sharecostparticipant: Array<string> = [];
    
    //*******************************************************
    constructor (
                  private _Activatedroute:ActivatedRoute,
                  private firestoredata: firestorecontrol, 
                  private appfunction: appfunctions,
                  private liststruct: liststructures,
                  private cdRef: ChangeDetectorRef,
                  @Inject(LOCALE_ID) public locale: string
                ) 
      { 

        this.saveClick = this.saveClick.bind(this);
        this.cancelClick = this.cancelClick.bind( this); 
        
        
        this.schedulerclick = this.schedulerclick.bind( this);
        this.serviceclick   = this.serviceclick.bind( this);

        this.validstartdateinput  = this.validstartdateinput.bind( this );
        this.validenddateinput    = this.validenddateinput.bind( this );
        this.validbudgetinput    = this.validbudgetinput.bind( this );

        this.validcollabstatus  = this.validcollabstatus.bind( this );

        this.saveCollaboratorClick = this.saveCollaboratorClick.bind(this);
        this.cancelCollaboratorClick = this.cancelCollaboratorClick.bind( this);
        
        this.collaboratorcostallocclick = this.collaboratorcostallocclick.bind( this );

       this.calculateShareCostSummary = this.calculateShareCostSummary.bind(this);

      // this.ShareCost = this.ShareCost.bind(this);

        this.labelTemplates = 
          [
            { name: 'name',       icon: 'dx-icon-user' },
            { name: 'position',   icon: 'dx-icon-info' },
            { name: 'date',       icon: 'dx-icon-event' },
            { name: 'address',    icon: 'dx-icon-home' },
            { name: 'phone',      icon: 'dx-icon-tel' },
            { name: 'email',      icon: 'dx-icon-email' },
            { name: 'mobile',     icon: 'fa-solid fa-mobile-retro' },
            { name: 'note',       icon: 'fa-regular fa-note-sticky'},
            { name: 'food',       icon: 'fa-solid fa-bowl-food'},
            { name: 'road',       icon: 'fa-sharp fa-solid fa-road'},
            { name: 'letter',     icon: 'fa-solid fa-square-envelope'},
            { name: 'address',    icon: 'fa-solid fa-address-card'}
          ];

      }
    //*******************************************************
    ngOnInit(): void 
      {
        //---------------------------------------------------------------------------------------------
        // EventId
        this.eventid     = String(this._Activatedroute.snapshot.paramMap.get("eventid"))
        // Form Height
        this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));
        // Date Format

       // console.log( this.locale )
      //  console.log( this.localeDate )

      // This set as default
     // const shortDateFormat = getLocaleDateFormat('en-US' , FormatWidth.Short);
     // console.log( shortDateFormat )

       const shortDateFormat = getLocaleDateFormat('en-AU' , FormatWidth.Short);
     // console.log( shortDateFormat )
        
        this.dateformat = shortDateFormat; // d/M/yy
        //this.dateformat  = 'dd/MM/yy'
        //---------------------------------------------------------------------------------------------
        // Establish Connection to event -> eventparticipant
        this.firestoredata.loadtaskgantt( this.eventid, 1, '' );

        this.subscriptiontodo = this.firestoredata.geteventtaskgantt().subscribe
          ( items => 
            { 
              this.subscriptiontodolist = items;
             // this.tasks  =  this.subscriptiontodolist
             // console.log( this.subscriptiontodolist  )
            }
          )
        //---------------------------------------------------------------------------------------------
        this.firestoredata.loadtaskganttdependency( this.eventid )
        
        this.subscriptiontododependency = this.firestoredata.geteventtaskganttdependency().subscribe
          ( items => 
            { 
              this.subscriptiontodolistdependencylist = items;
              //---------------------------------------------------------------------------------------------
              // Establish Gantt Min and Max Date of tasks 
              this.gantttodo.instance.refresh().then( () =>  {
              setTimeout( () => {
                                  try {
  
                                        if (typeof this.gantttodo.instance?.getVisibleTaskKeys() != undefined )
                                          {
                                            const visibleTaskKeys = this.gantttodo.instance?.getVisibleTaskKeys();

                                            //console.log(  visibleTaskKeys.length )
  
                                            if ( visibleTaskKeys.length > 0 )
                                              {
                                               
                                                this.getMinMaxDate_Gantt_Task(); // Determine minimum and maximunm
                                                
                                              }
                                          }
                                      } catch (error) {
                                                        console.log(error);
                                                      }
                                }, 
                                1000 // One Seconds
                          );
                
                  }
              )
            //---------------------------------------------------------------------------------------------
            }
          )
        //---------------------------------------------------------------------------------------------
        // Event Organiser Initials
        this.firestoredata.buildwhoseguestdetails( this.eventid );
        this.whoseguest = this.firestoredata.geteventparticipantdetails();
        //---------------------------------------------------------------------------------------------
        // Collaborator Status
        this.collaboratorstatus = this.liststruct.getcollaboratorstatus();
        //---------------------------------------------------------------------------------------------
        // Declare empty values for collaborator details
        this.collaboratordetails = [];  // Declare Empty Array

        this.collaboratordetails.push(   
                                        {
                                          id: '',
                                          providername: '',
                                          street: '',
                                          suburb:'',
                                          state: '',
                                          postcode: '',
                                          phone: '',
                                          mobile: '',
                                          email: '',
                                          contactperson: '', 
                                          statuslist: '',    
                                          amount: 0,
                                          notes: '',
                                          parenttaskid: '',
                                          ganttId: '',      
                                          triggerrefresh: ''
                                        }
                                      );
        //---------------------------------------------------------------------------------------------
      }
    //*******************************************************
    getMinMaxDate_Gantt_Task()
      {   
        // console.log( this.gantttodo.instance.getVisibleTaskKeys().length )
        var minDate: Date;
        var maxDate: Date;

        var ganttminDate: Date;
        var ganttmaxDate: Date;

        
       if ( this.gantttodo.instance.getVisibleTaskKeys().length > 0 )
        {
          // Current Task Keys visible on the Gannt Chart
          const ganttlist = this.gantttodo.instance.getVisibleTaskKeys()

          // Get First Array to set min and max dates
            let result = this.subscriptiontodolist.find(({ id }) => id === ganttlist[0]);

            minDate = new Date(Date.parse(result.start));
            maxDate = new Date(Date.parse(result.end));

            if ( this.gantttodo.instance.getVisibleTaskKeys().length > 1 )
              {

                for (let i = 1; i < ganttlist.length; i++) 
                  {   
                    let result = this.subscriptiontodolist.find(({ id }) => id === ganttlist[i]);

                    if ( new Date(Date.parse(result.start)) < minDate) 
                      {
                        minDate = new Date(Date.parse(result.start));
                      }

                    if ( new Date(Date.parse(result.end))> maxDate) 
                      {
                        maxDate = new Date(Date.parse(result.end));
                      }

                  }

              }
              
         
          this.gantttodo.instance.beginUpdate();

          ganttminDate = new Date(  minDate.getFullYear(), minDate.getMonth(),  minDate.getDate());
          ganttminDate.setDate( minDate.getDate() - 60)

          this.ganttstartdate = ganttminDate;
  
          ganttmaxDate = new Date(  maxDate.getFullYear(), maxDate.getMonth(),  maxDate.getDate())
          ganttmaxDate.setDate( maxDate.getDate() + 60)

          this.ganttenddate = ganttmaxDate
         // console.log ( ganttminDate + '-' + ganttmaxDate)

          this.gantttodo.instance.endUpdate();

        }


      }
    //*******************************************************
    ngAfterViewInit() 
      {
        this.cdRef.detectChanges();
      }
    //*******************************************************
    ngAfterContentChecked(): void 
      {
      //  this.cdRef.detectChanges();
      }
    //*******************************************************  
    ngOnDestroy() 
      {
        this.subscriptiontodo.unsubscribe(); 
        this.subscriptiontododependency.unsubscribe();

        if (typeof this.subscriptionscheduler != 'undefined'  )
          {
            this.subscriptionscheduler.unsubscribe()
          }

        if (typeof this.subscriptioncollaborator != 'undefined'  )
          {
            this.subscriptioncollaborator.unsubscribe()
          }
      
      }
   //*******************************************************
   // Insert a New Task 
   onTaskInserting( event: any )
    {
      // console.log( event )
      // console.log( event.values.parentId )

      // Indicate that a New Task is being created
      this.statusinsert = true;
      // Create new ganttid = new task id
      this.ganttid      = this.appfunction.createuniqueid(4)

      // Default New Task Detials
      if ( event.values.parentId == null ) 
        {
          // New Task
         // Default Title 
          event.values.title          = 'New Task ?'
          event.values.taskconfirm    = false;
          this.parentID               = 0
          this.parenttaskid           = this.ganttid;
        }
      else
        {
          if ( event.values.parentId  == 0 )
            {
              event.values.title          = 'New Task ?'
              event.values.taskconfirm    = false;
              this.parentID               = 0
              this.parenttaskid           = this.ganttid;
            }
          else
            {
              event.values.title          = 'New Sub Task ?'
              event.values.taskconfirm    = false;
              this.parentID               = event.values.parentId; 
            } 
        }

    }
  //*******************************************************
  onTaskInserted( event: any)
    {
      var taskstartdate: Date;
      var taskenddate: Date;
      var startdate: string;
      var enddate: string;

      //console.log( event )
    
      // Each New Task / Sub Task will begin with
      // a. Start date as the current date
      taskstartdate = new Date;
      // By Default End
      // b. End Date as the current date + 29 days
      taskenddate  = new Date;
      taskenddate.setDate( taskenddate.getDate() + 29 )

      startdate = formatDate( taskstartdate, 'yyyy-MM-ddTHH:mm:ss', 'en' );
      enddate   = formatDate( taskenddate,   'yyyy-MM-ddTHH:mm:ss', 'en' );

      // Id for ParentId. New Task = 0. Subtask = Parentid will its parent
      event.values.parentId = this.parentID;
      event.values.start    = startdate;
      event.values.end      = enddate;


      //    console.log( event )

      //   console.log( event.values )
      //   console.log( event.values.parentId )
      //  console.log( event.values.title )

      // Update New Task or New Sub task
      this.firestoredata.addNewGanttTask(  this.eventid, this.ganttid, this.parenttaskid  , event  ).then( () =>  {
                                                                                                                    this.statusinsert = false;
                                                                                                                  }
                                                                                                            
                                                                                                          ).then( () =>  {  
                                                                                                                            //---------------------------------------------------------------------------------------------
                                                                                                                            console.log( 'Update Gantt Min & Max Dates')
                                                                                                                         
                                                                                                                            //---------------------------------------------------------------------------------------------
                                                                                                                          }

                                                                                                                );
      // Insert Dependency
      this.firestoredata.addNewGanttTaskDependency(  this.eventid, this.ganttid  );
      //---------------------------------------------------------------------------------------------                                                                                                                
    
    }
  //*******************************************************
  onTaskEditDialogShowing(event: any)
    {
      // Prevent Default Standard Task Detail Form from showing
      event.cancel = true;
      // Show Task Details
      this.showTaskDetails( this.gantttodo.instance.getTaskData( event.key ))
    }
  //*******************************************************
  showTaskDetails( data: any )
    {
   
      this.formData  = data;
      this.formDataVarible = data;
      // Set formData.progress = this.progress
      this.progress1 =  this.formDataVarible.progress;

    
      this.popuptaskdetailVisible = true;
    
    }
  //*******************************************************
  onTaskUpdated( event: any)
    {
      //console.log( event )
      //---------------------------------------------------------------------------------------------
      // Task - start | end | start & end = date change
      // Only Start date is changed
      if ( ( event.values.start != null && event.values.end == null ) || 
           ( event.values.start == null && event.values.end != null ) ||
           ( event.values.start != null && event.values.end != null ) )
        { 
          this.firestoredata.updateGanttTaskStartEndDate( this.eventid, event.key, event.values.start, event.values.end ).then
            ( () =>  {  
                        //---------------------------------------------------------------------------------------------
                       // console.log( 'Update Gantt Min & Max Dates')

                        setTimeout( () => {
                                            try {

                                                  if (typeof this.gantttodo.instance?.getVisibleTaskKeys() != undefined )
                                                    {
                                                      const visibleTaskKeys = this.gantttodo.instance?.getVisibleTaskKeys();

                                                      if ( visibleTaskKeys.length > 0 )
                                                        {
                                                          this.getMinMaxDate_Gantt_Task(); // Determine minimum and maximunm
                                                        }
                                                    }
                                                } catch (error) {
                                                                  console.log(error);
                                                                }
                                            }, 
                                            1000 // One Seconds
                                    );
                        //---------------------------------------------------------------------------------------------
                      }
            );
        }
      //---------------------------------------------------------------------------------------------
    }
  //---------------------------------------------------------------------------------------------
  onTaskDeleted( event: any )
    {
     
      // Hannah
      console.log( event )
      console.log( event.values.id + ' ' + event.values.parentId + ' ' + this.parenttaskid)

      // Set Default to Delete = cancel. Wont delete any Gantt Task when selected
      event.cancel = true;

      // Determine whether Ganntt Task can be deleted
      // Must have NO Child tasks before it can be deleted
      // If it can deleted the Observable will force a refresh and the Gannt Task be removed
      this.firestoredata.cnttask( this.eventid, event.values.id, event.values.parentId, this.parenttaskid)
                      .then ( ( value ) => {
                                              const nocnt: number = value;

                                              console.log( 'nocnt:' +  nocnt )

                                              if ( nocnt > 0 )
                                                {
                                                  return false
                                                }
                                              else
                                                {
                                                  return true
                                                }
                                           }
                      ).then( result => {
                                          

                                            if ( result )
                                                {
                                                  this.firestoredata.deleteGanttTask( this.eventid, event.values.id );
                                                }
                                            else
                                                {

                                                  this.displayToast( 'Task deletion prevented. There are subtask.', 'error', 5000, '300' )
                                                }
                                        }
                            )

                                       

                                           
    }
  //---------------------------------------------------------------------------------------------  
  onDependencyInserted( event: any )
    {
      //console.log( event )
      this.firestoredata.updateGanttTaskDependency( this.eventid, event );
    }
  //---------------------------------------------------------------------------------------------
  onDependencyDeleted(  event: any )
    {
      //console.log( event )
      this.firestoredata.deleteGanttTaskDependency( this.eventid, event );
    }
  //---------------------------------------------------------------------------------------------
  OnSelectionChanged( event: any )
    {
    
      let currentTask = this.subscriptiontodolist.find(p => p.id == event.selectedRowKey);

      if (  currentTask != undefined ) 
        {

          if ( this.statusinsert == false ) 
            {
              this.parenttaskid = currentTask.parenttaskid;
              this.gantttaskid  = currentTask.id;
            }

        }

    }
  //*******************************************************
  // Save Task Detail Details
  saveClick()
    {
    
      let validresult = this.formtodotask.instance.validate();
   
      if ( validresult.isValid )
        {
          //console.log( 'Valid')

          // Update Firestore for Task Details
          var taskdetail: any = this.formData

         // console.log( taskdetail )

          this.firestoredata.updateGanttTask(  this.eventid, taskdetail ).then
                                                                                ( () =>  {  
                                                                                            //---------------------------------------------------------------------------------------------
                                                                                            console.log( 'Update Gantt Min & Max Dates')
                                                                                          
                                                                                            setTimeout( () => {
                                                                                                                try {
                                                                                
                                                                                                                      if (typeof this.gantttodo.instance?.getVisibleTaskKeys() != undefined )
                                                                                                                        {
                                                                                                                          const visibleTaskKeys = this.gantttodo.instance?.getVisibleTaskKeys();
                                                                                
                                                                                                                          if ( visibleTaskKeys.length > 0 )
                                                                                                                            {
                                                                                                                              this.getMinMaxDate_Gantt_Task(); // Determine minimum and maximunm
                                                                                                                            }
                                                                                                                        }
                                                                                                                    } catch (error) {
                                                                                                                                      console.log(error);
                                                                                                                                    }
                                                                                                                }, 
                                                                                                                1000 // One Seconds
                                                                                                        );
                                                                                            //---------------------------------------------------------------------------------------------
                                                                                          }
                                                                                );
          this.popuptaskdetailVisible = false;

        }
      else
        {
          console.log( 'InValid')
        }
                
    }
  //*******************************************************
   // Cancel Task Detail Details
  cancelClick()
    {
      this.popuptaskdetailVisible = false;
    }
  //******************************************************* 
  schedulerclick( event: any)
      {

       // console.log( event )
        if ( event.row.rowType == "data")
          {
            this.schedulerparenttaskid  = event.row.node.data.parenttaskid

            this.parenttaskid = event.row.node.data.parenttaskid;
            this.gantttaskid  = event.row.node.data.id;
            
            //console.log(  this.schedulerparenttaskid   )
            this.positionOf           =  `#taskid${event.row.data.id}`;
            this.popupscheduleVisible = true;
          }
        
       
        //this.positionOf           =  `#btnscheduler`;
      }
  //*******************************************************
  onShowingCollaborator( event: any )
      {
        //---------------------------------------------------------------------------------------------
        // Establish Connection to Ganntt Parent -> Scheduler Items
       // console.log(  this.gantttaskid )

        this.firestoredata.loadeventcollaborator( this.eventid, 10,  this.gantttaskid, []  );
        
        this.subscriptioncollaborator = this.firestoredata.geteventcollaborator().subscribe
          ( items => 
            { 
              this.subscriptioncollaboratorlist = items;
             // console.log( this.subscriptioncollaboratorlist )
            }
          )
        //---------------------------------------------------------------------------------------------
      }
  //*******************************************************
  onShowingScheduler( event: any )
      {
       
        //---------------------------------------------------------------------------------------------
        // Establish Connection to Ganntt Parent -> Scheduler Items
        this.firestoredata.loadscheduler( this.eventid, 1, 10,  this.schedulerparenttaskid, null, null );

        this.subscriptionscheduler = this.firestoredata.getscheduler().subscribe
          ( items => 
            { 
              this.subscriptionschedulerlist = items;
            }
          )
        //---------------------------------------------------------------------------------------------

      }
  //*******************************************************
  onAppointmentDblClick( event: any)
      {
        event.cancel = true;
      }

  onAppointmentFormOpening(event: any ) 
    {
      //---------------------------------------------------------------------------------------------
     // if ( this.onAppointmentFormOpeningStatus != true )
     //   {
      //    event.cancel = true;
      //  }
      //---------------------------------------------------------------------------------------------
      const that = this;
      const form = event.form;
    
      // Default Start dates
      this.currentsdate = event.appointmentData.startDate
      this.currentedate = event.appointmentData.endDate
      //console.log( this.currentsdate + ' ' + this.currentedate )
      //---------------------------------------------------------------------------------------------
      // James
      // PopUp Form
      event.popup.option( 
                          {
                            width: 500,
                            height: 430,
                            'showTitle': true,
                            position: { my: 'right', 
                                        at: 'top', 
                                        of: "popscheduler", 
                                        offset: { x: 18, y: 410 }   
                          
                          
                                      }
                               
                          }
                          
                          
                        )

      event.popup.option('title', 'Edit Appointment');
      if (  event.appointmentData.title  == undefined )
        {
          event.popup.option('title', 'Create a new appointment');
        }
      //---------------------------------------------------------------------------------------------
      // Form Option
      form.option("width",  460);
      form.option("height", 350);
      form.option("colCount", 3);
      
      form.option('items',
                        [

                          {
                              itemType: "group",
                              caption: "Schedule",
                              colSpan: 3,
                              colCount: 3,
                              items: [

                                        {
                                          dataField: 'title',
                                          editorType: 'dxTextBox',
                                          colSpan: 3,
                                          label:  {
                                                    text: 'Subject',
                                                  },
                                          editorOptions: 
                                                  {
                                                    type: 'string',
                                                    width: 460
                                                  },
                                          validationRules: [
                                                              {
                                                                type: 'required',
                                                                message: 'Subject is required'
                                                              }
                                                           ]
                                        },
                                       
                                        {
                                          dataField: 'startDate',
                                          editorType: 'dxDateBox',
                                          label:  
                                            {
                                              text: 'Start',
                                            },
                                          editorOptions: 
                                            {
                                              type: 'datetime',
                                              onValueChanged(args) {
                                                                     // this.currentsdate = args.value;
                                                                   },
                                              width: 150,
                                            },
                                          validationRules: 
                                            [
                                              {
                                                type: 'custom',
                                                reevaluate:'true',
                                                validationCallback: function( e )
                                                                            {
                                                                             
                                                                              if ( event.appointmentData.endDate  >  e.value )
                                                                                {
                                                                                  return true
                                                                                }
                                                                              else
                                                                                {
                                                                                  return false
                                                                                }
                                                                            },
                                                message: 'Please recheck start & End'
                                              }
                                            ]
                                        },

                                        {
                                          dataField: 'endDate',
                                          editorType: 'dxDateBox',
                                          label:  
                                            {
                                              text: 'End',
                                            },
                                          editorOptions: 
                                            {
                                              type: 'datetime',
                                              onValueChanged(args) {
                                                                      ///this.currentedate = args.value;
                                                                    },
                                              width: 150,
                                            },
                                          validationRules: 
                                            [
                                              {
                                                type: 'custom',
                                                reevaluate:'true',
                                                validationCallback: function( e )
                                                                            {
                                                                             
                                                                              if ( e.value >  event.appointmentData.startDate )
                                                                                {
                                                                                  return true
                                                                                }
                                                                              else
                                                                                {
                                                                                  return false
                                                                                }
                                                                            },
                                                message:  'Please recheck start & End'
                                              }
                                            ]
                                        },

                                        {
                                          dataField: 'allDay',
                                          editorType: 'dxCheckBox',
                                          
                                          editorOptions: 
                                            {
                                              type: 'boolean',
                                              width: 150,
                                            }
                                        },

                                        {
                                          dataField: 'description',
                                          editorType: 'dxTextArea',
                                          colSpan: 3,
                                          label:  {
                                                    text: 'Notes',
                                                  },
                                          editorOptions: 
                                                  {
                                                    type: 'string',
                                                    width: 460,
                                                    height: 120
                                                  }
                                        },

                                       
                                     ]


                          }

                        ]
                    )

      }
  //*******************************************************
  validcollabstatus(e): boolean
    {
      var statusinput: any

      statusinput = e.value;

      if ( statusinput != null )
        {
          return true
          //***************** CODE BELOW TO ENSURE THAT ONLY ONE COLLABORATOR IS DEEM CONFIRM **********************************
          //***************** CODE IS COMMENT OUT FOR POSSIBLE FUTURE USE **********************************
          /*  if ( statusinput == 'Confirm' )  // Current entered Satus
            {

              if ( this.focusedCollaboratorOldStatus != 'Confirm' )
                {
                  this.collabstatusinputvalmsg = '';
                  // Validate that there is no other confirm status
                  this.firestoredata.cntcolloboratorconfirm( this.eventid, this.focusedCollaboratorGanttid )
                      .then ( ( value ) => {
                                              const nocnt: number = value;

                                             // console.log( 'nocnt:' +  nocnt )

                                              if ( nocnt > 0 )
                                                {
                                                  this.collabstatusinputvalmsg = 'There is another Collaborator marked Confirm'
                                                  return false
                                                }
                                              else
                                                {
                                                  return true
                                                }
                                           }

                            )

                  return false
               
                }
              else
                {
                 return true
                }
            }
          else
            {
              return true
            }
          
        }
      else
        {
          return false;
        }
      */
      }
    else
      {
        return false;
      }

    }
  //*******************************************************
  validenddateinput(e): boolean
  {
    var dateinput: any

    dateinput = e.value;

    if ( dateinput != null )
      {

        if ( dateinput >= this.formDataVarible.start )
          {
            return true
          }
        else
          {
            this.enddateinputvalmsg = "End Date < Start Date is required"
            return false
          }

      }
    else
      {
        this.enddateinputvalmsg = "End Date is required"
        return false 
      }
     
  }
//*******************************************************
validstartdateinput(e): boolean
    {
      var dateinput: any

      dateinput = e.value;

      if ( dateinput != null )
        {

          if ( this.formDataVarible.end >= dateinput )
            {
              return true
            }
          else
            {
              this.startdateinputvalmsg = "Start Date > End Date is required"
              return false
            }

        }
      else
        {
          this.startdateinputvalmsg = "Start Date is required"
          return false 
        }


    }
  //*******************************************************
  validbudgetinput(e): boolean
  {
    var budgetinput: any

    budgetinput = e.value;

    if ( budgetinput != null )
      {

        if ( budgetinput >= 0 )
          {
            return true
          }
        else
          {
            this.budgetinputvalmsg = "Budget Number cannot < 0"
            return false
          }

      }
    else
      {
        this.budgetinputvalmsg = "Budget Number is required"
        return false 
      }
     
  }
//*******************************************************
  onAppointmentAdding( event: any)
    {
     // console.log('Add')

     // console.log(event)

      this.firestoredata.addNewSchedule( this.eventid, event.appointmentData, this.parenttaskid, this.gantttaskid );

    }
  //*******************************************************
  onAppointmentUpdated( event: any )
    {
      //console.log('Update')
      //console.log(event)
      this.firestoredata.updateSchedule( this.eventid, event.appointmentData );
    }
  //*******************************************************
  onAgendaAppointmentClick( event: any )
    {

      var seldate: Date;
      var scrolldate: Date;
      var agendaseldate: Date;
      var SelYear: number;
      var SelMth: number;
      var SelDay: number;
      var SelHr: number;
      var SelMin: number;

      // Gets the Date Selected from the Agenda 
      // Set the Date for View Scheduler
      this.scheduleview = 'day';

      this.scheduler.instance._refresh;
     

      agendaseldate     = new Date ( event.appointmentData.startDate );
     // console.log( agendaseldate )
      seldate             = agendaseldate;

      SelYear = seldate.getFullYear();
      SelMth  = seldate.getMonth() + 1;
      SelDay  = seldate.getDate();
      SelHr   = seldate.getHours();
      SelMin  = seldate.getMinutes();
      //console.log( SelYear + '#' + SelMth + '#' + SelDay + '#' + SelHr + '#' + SelMin)

      
      let end                 = formatDate( agendaseldate, 'yyyy-MM-dd', 'en' );
    //  console.log( end )

      scrolldate  = new Date( SelYear, SelMth-1, SelDay )

     this.currentDate  = end

      //console.log( this.currentDate )
     // this.scheduler.instance.scrollTo( new Date( SelYear, SelMth-1, SelDay, 0, 0) )

     
        this.scheduler.instance.scrollTo( new Date( SelYear, SelMth-1, SelDay, SelHr, SelMin) )
    
    
    
         // this.scheduler.instance.scrollToTime(SelHr,SelMin, scrolldate  );                              
    }
  //*******************************************************
  onAgendaAppointmentDblClick( event: any )
    {
      // Suppress opening 
      event.cancel = true;
    }
  //*******************************************************
  onAppointmentTooltipShowing( event:any, seloption: number )
    {
      switch ( seloption )
        {
          case 1: 
            {
              event.cancel = true;
              break;
            }

        }

    }
  //*******************************************************
  onContentReadyAgenda( event: any)
    {
      let toolbarInstance = Toolbar.getInstance( event.component.element().find(".dx-toolbar") );
    
      let items = toolbarInstance.option("items");

      toolbarInstance.option("items", [
                                        items[0],
                                        {
                                          widget: "dxSelectBox",
                                          
                                          options: {
                                                      width: 50,
                                                      value:  this.agendaageduration,
                                                      dataSource: [
                                                                      7,
                                                                      14,
                                                                      30,
                                                                      60,
                                                                      120,
                                                                      240,
                                                                      360 
                                                                  ],

                                                      
                                                      onValueChanged: (args) =>   {
                                                                                    this.agendaageduration = args.value;
                                                                                  }
                                                    },
                                          location: "after"
                                        }
                                      ]
                              );

      //x  console.log(toolbarInstance.option("items"));

      // if ( toolbarInstance.length == 2) 
      //   {
          //  console.log( 'James ')

      //   console.log(  toolbarInstance.option("items").length  )

    }
  //*******************************************************
  customizeAgendaDateNavigatorText = (e) => 
    {

      let formatOptions = { 
                              year:   '2-digit', 
                              month:  'numeric', 
                              day:    'numeric' 
                          };

      //console.log( e )
      //  var formattedStartDate = e.startDate.toLocaleString("en", formatOptions);
      var formattedStartDate = formatDate(e.startDate,  this.dateformat , 'en');

      var formattedEndDate = formatDate(e.endDate,  this.dateformat , 'en');
    
      return formattedStartDate + "-" + formattedEndDate;
  
  }
  //*******************************************************
  serviceclick( event: any)
  {
    if ( event.row.rowType == "data")
      {
        
        this.schedulerparenttaskid  = event.row.node.data.parenttaskid

        this.parenttaskid           = event.row.node.data.parenttaskid;
        this.gantttaskid            = event.row.node.data.id;
        this.gantttaskbudget        = event.row.node.data.budget; // From Gantt Task 
        this.statusflag             = 'Hide'

        this.positionOf             =  `#taskid${event.row.data.id}`;

        // Set Service - Collaborators Details to Blank;
        // Set Array to capture and show collaborator details
        if ( this.collaboratordetails.length > 0 )
          {
            this.collaboratordetails    = [];
            this.collaboratordetails.push(   
              {
                id: '',
                providername:  '',
                street:'',
                suburb: '',
                state: '',
                postcode: '',
                phone: '',
                mobile: '',
                email: '',
                contactperson: '', 
                statuslist: '',    
                amount: 0,
               // budget: this.gantttaskbudget,
                budget: 0,
                notes:  '',
                parenttaskid: '',
                ganttId: '',      
                triggerrefresh: ''
              }
            );
          }
     

        // Make PopUp Visible
        this.popupserviceVisible    = true;
      }
   
    //this.positionOf           =  `#btnscheduler`;
  }
//*******************************************************
onDeleteButtonClick(event: any, appointmentData: any): void 
  {
    //---------------------------------------------------------------------------------------------  
    this.myDialog = custom(
      {
          title: "Appointment",
          messageHtml: "<b>Remove Appointment</b>",
          buttons: [
                      {
                        text: "Yes",
                        onClick: (e) => {
                                          return { buttonText: e.component.option("text") }
                                        }
                      },
                      {
                        text: "No",
                        onClick: (e) => {
                                          return { buttonText: e.component.option("text") }
                                        }
                      }

                    ]
        }
    );
    //---------------------------------------------------------------------------------------------    
    this.myDialog.show().then((dialogResult) => {
                                                  // console.log(dialogResult.buttonText);

                                                   if  ( dialogResult.buttonText == 'Yes')
                                                    {
                                                      // Create Firestore Deletion
                                                      this.firestoredata.deleteSchedule(  this.eventid, appointmentData.id)
                                                    }

                                                  //this.onAppointmentFormOpeningStatus = true;
                                                }
                              );
    //---------------------------------------------------------------------------------------------
    event.event.stopPropagation();
    this.scheduler.instance.hideAppointmentTooltip();
  }
//*******************************************************
onValueChangedSlider(event: any)
  {
   // console.log( this.formDataVarible  )
    this.progress1  = event.value
    this.formDataVarible.progress = this.progress1
  
  }

sliderformat(value) 
  {
    return `${value}%`;
  }
//*******************************************************
collaboratorform( event: any, seloption: number)
  {
    var status: boolean
    //---------------------------------------------------------------------------------------------
    this.selButton          = seloption;    // Which Button Add=10 or Edit=20 
    this.statusvaluechange  = false;        // Detect any changes it formdata fields
    this.statusflag         = 'Hide';
    //---------------------------------------------------------------------------------------------
    // Determine whether a ROW is selected when its not a ADD option
    if ( this.selButton  != 10 )
      {
      
        if ( this.rowCollaboratorSelect ) 
          {
            status             = true;
          }
        else
          {
            status             = false; 
          }
     }
    //---------------------------------------------------------------------------------------------
    switch ( seloption )
      {
        //---------------------------------------------------------------------------------------------
        // Add Collaborator
        case 10:
            {
              //---------------------------------------------------------------------------------------------
              // Set Inputs to default values
              this.formcollaboratorData                         = [];
              let collaboratid                                  = this.appfunction.createuniqueid(6) 
              //---------------------------------------------------------------------------------------------
              // Assign Values
              this.formcollaboratorDataVarible                  = this.formcollaboratorData;

              this.selcollaboratorstatus                        = 'Listed'  // Default Value

              this.formcollaboratorDataVarible.id               = collaboratid;
              this.formcollaboratorDataVarible.statuslist       = this.selcollaboratorstatus;

              this.formcollaboratorDataVarible.amount           = 0;

             // this.formcollaboratorDataVarible.budget           = this.gantttaskbudget;
              this.formcollaboratorDataVarible.budget           = 0;

              this.formcollaboratorDataVarible.category         = 'TBC';
              this.formcollaboratorDataVarible.providername     = '';
              this.formcollaboratorDataVarible.contactperson    = '';
              this.formcollaboratorDataVarible.mobile           = '';
              this.formcollaboratorDataVarible.phone            = '';
              this.formcollaboratorDataVarible.email            = '';
              this.formcollaboratorDataVarible.notes            = '';
              this.formcollaboratorDataVarible.street           = '';
              this.formcollaboratorDataVarible.suburb           = '';
              this.formcollaboratorDataVarible.state            = '';
              this.formcollaboratorDataVarible.postcode         = '';
              this.formcollaboratorDataVarible.ganttId          = this.gantttaskid;
              this.formcollaboratorDataVarible.parenttaskid     = this.parenttaskid
              //---------------------------------------------------------------------------------------------
              // Set Default Value to Collaborator FormData 
              this.formcollaboratorData = this.formcollaboratorDataVarible;

             // console.log( this.formcollaboratorData  )
              //---------------------------------------------------------------------------------------------
              this.popuptitle                 = 'Add Collaborator';
              this.popupcollaboratorVisible   = true;
              this.buttondisable              = true;

              break;  
            }
        //---------------------------------------------------------------------------------------------
        // Edit Collaborator
        case 20:
          {
            if ( status )
              {

                  this.popuptitle                = 'Edit Collaborator';
                  this.popupcollaboratorVisible  = true;
              }

            break;  
          }
        //---------------------------------------------------------------------------------------------
    
      }

  }
  //---------------------------------------------------------------------------------------------
  onrowCollaboratorclick( event: any )
    { 
      this.rowCollaboratorSelect = true;               // Indicate that Datagrid - Collabprator Row has been selected
      
      this.buttondisable = false;                      // Enable Collaborator form buttons

      this.statusflag   = 'Hide';                      // Hide Allocate Cost Form to force click on Button - Collabotrator Allocate Cost

      // Capture Select Row Data Id
      this.focusedCollaboratorRowKey        = event.data.id;  // Register Data Row - id
      this.focusedCollaboratorOldStatus     = event.data.statuslist;
      this.focusedCollaboratorGanttid       = event.data.ganttId;
      this.focusedCollaboratorCurrActCost   = event.data.amount;
      this.focusedCollaboratorCurrBudCost   = event.data.budget;
      this.focusedCollaboratorStatusList    = event.data.statuslist;

      // Store data to Variable
      this.collaboratordataprofile( 10, event )               // Store Data Row Data
    }
  //---------------------------------------------------------------------------------------------
  onrowCollaboratorchange( event: any )
    {
      this.rowCollaboratorSelect = true;                        // Indicate that Datagrid - Collabprator Row has been selected
     
      this.buttondisable = false;                               // Enable Collaborator form buttons 

      this.statusflag   = 'Hide';                               // Hide Allocate Cost Form to force click on Button - Collabotrator Allocate Cost
      
      // Capture Select Row Data Id
      this.focusedCollaboratorRowKey        = event.row.data.id;          // Register Data Row - id
      this.focusedCollaboratorOldStatus     = event.row.data.statuslist;
      this.focusedCollaboratorGanttid       = event.row.data.ganttId;

      this.focusedCollaboratorCurrActCost   = event.row.data.amount;
      this.focusedCollaboratorCurrBudCost   = event.row.data.budget;

    //  console.log( this.focusedCollaboratorCurrActCost + '-' + this.focusedCollaboratorCurrBudCost )
     
      // Save data
      this.collaboratordataprofile( 20, event )                    // Store Data Row Data

    }
  //---------------------------------------------------------------------------------------------
  collaboratordataprofile( settype: number,  seldata: any)
    {
      switch ( settype )
        {
          // Row Click
          case 10:
            {

              this.formcollaboratorData      = seldata.data;
              this.rowCollaboratordata       = seldata.data;   // Collaborator Data before any edit changes
            // console.log( seldata.data  )
              break;
            }

          // Row Change
          case 20:
            {
              this.formcollaboratorData      = seldata.row.data;
              this.rowCollaboratordata       = seldata.row.data;  // Collaborator Data before any edit changes
              break; 
            }

        }

    }
  //*******************************************************
  // Save Collaborator Detail 
  saveCollaboratorClick( event: any )
    {
    
      let validresult = this.formcollaborator.instance.validate();
   
      if ( validresult.isValid )
        {
          this.formcollaboratorDataVarible =  this.formcollaboratorData;
          //console.log( this.formcollaboratorDataVarible );

          // Update Firestore
          this.firestoredata.addUpdateCollaborator( this.selButton, this.eventid, this.formcollaboratorDataVarible, this.gantttaskbudget );

          this.popupcollaboratorVisible = false;
          //---------------------------------------------------------------------------------------------
          if ( this.selButton == 20 ) // Edit Button
            {
              //---------------------------------------------------------------------------------------------
              this.statusflag                  = this.formcollaboratorDataVarible.statuslist;
              this.buttondisable               = true;
              //---------------------------------------------------------------------------------------------
              // Collaborator statuslist has changed Confirm <> Listed OR Confirm <> Shortlist
              // Cost Allocation has to recalculate to 0
              if ( this.focusedCollaboratorStatusList == 'Confirm' )
                {
                  if ( this.focusedCollaboratorStatusList != this.formcollaboratorDataVarible.statuslist ) 
                    {

                      this.displayToast( 'Confirm Status has been reset. Cost will set back 0.', 'error', 5000, '300' )

                      this.firestoredata.addUpdateCollaborator( 30, this.eventid, this.formcollaboratorDataVarible, this.gantttaskbudget );

                    }
                }
              //---------------------------------------------------------------------------------------------
              // Actual Amount Changes <> Previous Opening Amount = Hide the Cost Allocation Screen
              // This will force the User to click Cost Allocation which will refesh Cost Allocation Array
              if ( ( this.focusedCollaboratorStatusList == this.formcollaboratorDataVarible.statuslist ) && 
                   (  this.focusedCollaboratorCurrActCost != this.formcollaboratorDataVarible.amount || 
                      this.focusedCollaboratorCurrBudCost != this.formcollaboratorDataVarible.budget    ) )
                 
                {
                  // When the 
                  this.statusflag = 'Hide';

                  this.displayToast( 'Actual and/or Budget Amounts have changed. You will need to recalculate cost allocation by clicking on Button - Calculator Button.', 'error', 5000, '300' )

                }
              //---------------------------------------------------------------------------------------------
            }
          //---------------------------------------------------------------------------------------------
        }
     
    }
  //---------------------------------------------------------------------------------------------
  cancelCollaboratorClick()
    {

      if ( this.statusvaluechange ) // If there is any changes but cancel update with previous data by trigger refresh
        {
          //---------------------------------------------------------------------------------------------
          if ( this.selButton == 20 )
            {
              // Update Firestore 
              this.firestoredata.commitbatchupdate( 
                                                    this.pathcollaborator, 
                                                    this.eventid,
                                                    this.focusedCollaboratorRowKey.toString(),
                                                    'triggerrefresh', 
                                                    this.appfunction.createuniqueid(3)
                                                  );  

              // Focus Row when cancel
              this.dataCollaboratorGrid.instance.clearSelection();
              this.dataCollaboratorGrid.instance.option("focusedRowKey",  -1 );
              setTimeout(() => {
                                  this.dataCollaboratorGrid.instance.option("focusedRowKey",  this.focusedCollaboratorRowKey  );
                                }, 100
                        );

              this.dataCollaboratorGrid.instance.focus();
            }
          //--------------------------------------------------------------------------------------------- 
      }
      //---------------------------------------------------------------------------------------------
      if ( this.selButton == 20 )
        {
          this.buttondisable = true;
        }
      //---------------------------------------------------------------------------------------------
      this.popupcollaboratorVisible = false;
    }
  //---------------------------------------------------------------------------------------------
  formCollaboratorDatafldchange( event: any )
    {
      // Formdata has changed
      this.statusvaluechange = true;
    }
  //*******************************************************
  onCellHoverCollaborator( event: any )
      {
        //**************************************************************
        var componentid   =  event.element[0].id
       //**************************************************************
        if ( componentid == "grideventcollaborator" )
          {
            if (  event.rowType == 'data' && event.eventType == 'mouseover' )
              {  
                // Declare Empty Array
                this.collaboratordetails = []; 

                // Collaborator Profile
                this.collaboratordetails.push(   
                                                {
                                                  id: event.data.id,
                                                  providername:  event.data.providername,
                                                  street: event.data.street,
                                                  suburb: event.data.suburb,
                                                  state: event.data.state,
                                                  postcode: event.data.postcode,
                                                  phone: event.data.phone,
                                                  mobile: event.data.mobile,
                                                  email: event.data.email,
                                                  contactperson: event.data.contactperson, 
                                                  statuslist: event.data.statuslist,    
                                                  amount:  event.data.amount,
                                                  notes:  event.data.notes,
                                                  parenttaskid:  event.data.parenttaskid,
                                                  ganttId:  event.data.ganttId,      
                                                  triggerrefresh:  event.data.triggerrefresh
                                                }
                                              );
                
              }
          }
         
      }
  //*******************************************************
  collaboratorcostallocclick( event: any)
    {
      //  console.log( event )
      //  console.log( event.row.data.sharecost )
      //  console.log( event.row.data.statuslist )
      // HannahWing

      this.collaboratorid   = event.row.data.id;
      this.sharecost        = event.row.data.sharecost; // Current Profile of Sharecost - Array
      this.collabcost       = event.row.data.amount;    
      this.collabbudcost    = event.row.data.budget;    

      // Build Sharecost Profile 
     // this.buildShareCostList(  this.sharecost, this.collabcost, this.gantttaskbudget )
     this.buildShareCostList(  this.sharecost, this.collabcost, this.collabbudcost  )

      this.statusflag = event.row.data.statuslist;
    }
  //---------------------------------------------------------------------------------------------
  buildShareCostList( sellist: any, selcost: number, selbudcost: number  )
    {
      //  console.log (  sellist  )
      //  console.log( sellist.length )
      // console.log( this.whoseguest)

      var organisercostprofile: string;
      var allocationperc: number;

      this.organisercostallocation = [];

      if ( sellist.length > 0 )
        {
          //---------------------------------------------------------------------------------------------
          for ( let i = 0; i <= sellist.length-1; i++ )
            { 
              organisercostprofile = sellist[i];
             
              const splitstr = organisercostprofile.split("#");
              allocationperc = +splitstr[1]

              this.organisercostallocation.push( {
                                                    id: splitstr[0],
                                                    percallocation: allocationperc,
                                                    confirmcost: selcost,       
                                                    confirmbudget: selbudcost,  
                                                    status: ''                                 
                                                  }
                                                );
            }
          //---------------------------------------------------------------------------------------------
          // Determine any new event organisers to update list
          if ( this.whoseguest.length != sellist.length )
            {
              // Update Array
              console.log( 'Update Array')
              for ( let i = 0; i <= this.whoseguest.length-1; i++ )
                {
                  let selorgid      = this.whoseguest[i].id;
                  let findselorgid  = this.organisercostallocation.find( p => p.id == selorgid )

                  if ( findselorgid == undefined )
                    {

                      console.log(  selorgid )

                      this.organisercostallocation.push( {
                                                            id: selorgid,
                                                          //  percallocation: allocationperc,
                                                            percallocation: 0,
                                                            confirmcost: selcost,       
                                                            confirmbudget: selbudcost,  
                                                            status: ''                                 
                                                          }
                                                        );

                    }

                }

            }
          //---------------------------------------------------------------------------------------------

          // This is triggered by clicking on button - to allocate cost amongst event organiser(s)
          // Update Firestore Collection - Collaborator -> flds sharecost [ array ] + sharecoststring
          // If allocations and/or actual amount current differs from previous Cloudstore Function will recalculate
          this.updateShareCost( null);

        }
      else
        {
          // New Organiser Build Profile
          for ( let i = 0; i <= this.whoseguest.length-1; i++ )
            { 
              
                this.organisercostallocation.push( {
                                                      id: this.whoseguest[i].id,
                                                      percallocation: 0,
                                                      confirmcost: selcost,       
                                                      confirmbudget: selbudcost,  
                                                      status: ''                                 
                                                    }
                                                    
                                                  );

            }

          // This is triggered by clicking on button - to allocate cost amongst event organiser(s)
          // Update Firestore Collection - Collaborator -> flds sharecost [ array ] + sharecoststring
          //
          // There should be 0 +/- cost changes from previous to current

          this.updateShareCost( null);
        }
            
    }
  //---------------------------------------------------------------------------------------------
  SetShareCost( newData, value, currentRowData )
    {
      newData.percallocation = value;
      newData.calcsharecost =  ( value / 100 ) * currentRowData.confirmcost;
    }
  //---------------------------------------------------------------------------------------------
  ShareCost( rowData: any )
    {
      return  rowData.confirmcost * ( rowData.percallocation / 100 ) 
    }
  //---------------------------------------------------------------------------------------------
  updateShareCost( event: any )
    {
    
      this.buildloadShareCostList( this.organisercostallocation )

      if (  this.saveorganisercostallocation.length > 0 )
        {
          
          console.log( this.saveorganisercostallocation )
          this.firestoredata.commitbatchupdate( 
                                                this.pathcollaborator, 
                                                this.eventid,
                                                this.collaboratorid,
                                                'sharecost', 
                                                this.saveorganisercostallocation
                                              );  

          this.firestoredata.commitbatchupdate( 
                                                  this.pathcollaborator, 
                                                  this.eventid,
                                                  this.collaboratorid,
                                                  'sharecoststring', 
                                                  this.saveorganisercostallocationstring
                                                );
                                                
          console.log( this.sharecostparticipant )
          this.firestoredata.commitbatchupdate( 
                                                  this.pathcollaborator, 
                                                  this.eventid,
                                                  this.collaboratorid,
                                                  'sharecostparticipant', 
                                                  this.sharecostparticipant
                                                );
        }
     
    }
  //---------------------------------------------------------------------------------------------
  buildloadShareCostList( sellist: any  )
    {
      var savecostprofile: string;
      var savecostprofilestring: string;

      var allocationperc: number;
      var organisersharestatus: string;

      this.saveorganisercostallocation = [];
      this.sharecostparticipant        = [];
      this.saveorganisercostallocationstring = '';

      if ( sellist.length > 0 )
        {

          for ( let i = 0; i <= sellist.length-1; i++ )
            { 
              //---------------------------------------------------------------------------------------------
              allocationperc        = sellist[i].percallocation
              organisersharestatus  = sellist[i].id + 'O'

              if ( allocationperc > 0 )
                {
                  organisersharestatus  = sellist[i].id + 'X'

                  // Identify EventOrganiser that has contributed to the cost of the event
                  this.sharecostparticipant.push( sellist[i].id )
                }
              //---------------------------------------------------------------------------------------------  
              savecostprofile                         = sellist[i].id             + '#' + 
                                                        sellist[i].percallocation + '#' + 
                                                        sellist[i].confirmcost    + '#' +
                                                        sellist[i].confirmbudget  + '#' +
                                                        organisersharestatus;

              this.saveorganisercostallocation.push ( 
                                                      savecostprofile
                                                    );
              //---------------------------------------------------------------------------------------------
              savecostprofilestring                   = sellist[i].id             + '#' + 
                                                        sellist[i].percallocation + '#' + 
                                                        sellist[i].confirmcost    + '#' +                
                                                        sellist[i].confirmbudget;

              this.saveorganisercostallocationstring  = this.saveorganisercostallocationstring + savecostprofilestring + ',';
              //---------------------------------------------------------------------------------------------
            }

            this.saveorganisercostallocationstring  = this.saveorganisercostallocationstring.substring(0, this.saveorganisercostallocationstring.length - 1)
           
        }

    }

    calculateShareCostSummary(options) 
    {
      if (options.name === "ShareCostSummary") 
      {

          if (options.summaryProcess === "start") 
            {
                options.totalValue = 0;
            }

          if (options.summaryProcess === "calculate") 
            {
             // console.log( options.value )
              options.totalValue += this.ShareCost(options.value)  
             // options.totalValue += options.value.confirmcost * ( options.value.percallocation / 100 ) ;
            }

          if (options.summaryProcess === "finalize") 
            {
              //console.log( options.totalValue)
            }
      }
  }

  //*******************************************************
  displayToast( toastmsg: string, toaststatus: string, toastdisplaysec: number, toastwidth: string )
    {

      this.toastFileMessage = toastmsg;
      this.toasttypeerror   = toaststatus;
      this.toastdisplaytime = toastdisplaysec;
      this.toastwidth       = toastwidth ;
      this.toastVisible     = true;

    }
  //*******************************************************
  checkBoxValidationCallback(params: any): boolean 
    {
      const value = params.value;
      return value === true || value === false;
    }
  //*******************************************************
  datagrideditorPreparing( event: any )
    {
      if (  event.rowType == "data"  && event.column.command =="edit" )
        {
        
          var $links = event.cellElement.find(".dx-link");
          // Remove Delete and Edit Icon
         // $links.filter(".dx-link-delete").remove();
          $links.filter(".dx-link-edit").remove();
        }
      }
  //*******************************************************
  getTaskColor(taskId) 
    {
      console.log( taskId )
      const color = taskId % 6;
      return `custom-task-color-${color}`;
    }   
  //*******************************************************
}
